"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-24 15:01:27
 * @LastEditTime: 2022-02-22 10:20:38
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\constant\chart\axis-pointer.ts
 */
exports.default = {
    default: {}
};
//# sourceMappingURL=axis-pointer.js.map